import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

export const createTimeline = async ({ orgId, dealId, postData }: { orgId: string; dealId: number; postData: any }) => {
    const response = await axiosInstance.post(API_ENDPOINTS.TIMELINES(orgId, dealId), postData);
    return response.data;
};

export const useCreateTimeline = () => useMutation({
    mutationFn: createTimeline,
});
